<template>
  <div class="container pull-up">
    <div class="row">
      <div class="col-md-12">
        <div class="card m-b-30">
          <div class="card-header">
            <h5 class="m-b-0">
              <i class="mdi mdi-checkbox-intermediate"></i> {{ $t('tax.button.all') }}
            </h5>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <data-tables :data="taxes"
                           :pagination-props="{ pageSizes: [10, 15, 30, 40, 100], pageSize: 10 }" center-align>
                <el-table-column label="S/N" type="index" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="name" :label="$t('tax.table.title.name')" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="rate" :label="$t('tax.table.title.rate')" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="type" :label="$t('tax.table.title.type')" ></el-table-column>
                <el-table-column prop="user.name" :label="$t('label.creator')" ></el-table-column>
                <el-table-column prop="created_at" :formatter="$shortDate" :label="$t('label.created_at')"
                                 sortable></el-table-column>
                <el-table-column label="Actions" min-width="100px">
                  <template slot-scope="scope">
                    <el-button v-can.disable="'tax.update'" @click="showEditDialog(scope.row.id)" split-button type="primary" size="small">
                      <i class="el-icon-edit"></i> {{ $t('button.edit') }}
                    </el-button>
                    <el-button v-can.disable="'tax.delete'" @click="taxDelete(scope.$index, scope.row.id)" :loading="loading" split-button type="danger" size="small">
                      <i class="el-icon-delete"></i> {{ $t('button.delete') }}
                    </el-button>
                  </template>
                </el-table-column>
              </data-tables>
            </div>
          </div>
        </div>
      </div>
    </div>
    <edit-tax :display="displayEditDialog" @close="closeEditDialog" @updated="taxUpdate"
                   @created="newTax" :tax="tax"></edit-tax>
  </div>
</template>

<script>
import CreateEditTax from './Modal/CreateEditTax.vue'

export default {
  name: 'Index',
  components: {
    'edit-tax': CreateEditTax
  },
  data () {
    return {
      loading: false,
      taxes: [],
      tax: {},
      displayEditDialog: false
    }
  },
  methods: {
    showEditDialog (id) {
      this.tax = this.taxes.find(d => d.id === id)
      this.displayEditDialog = true
    },
    closeEditDialog () {
      this.displayEditDialog = false
    },
    newTax (data) {
      this.taxes.splice(0, 0, data)
      this.refreshTaxList()
    },
    async refreshTaxList () {
      try {
        this.taxes = await this.$taxService.getTaxes()
      } catch (error) {
        console.log('Error refreshing tax list:', error)
      }
    },
    taxUpdate (data) {
      this.taxes.splice(this.taxes.indexOf(this.taxes.find(d => d.id === data.id)), 1, data)
      this.refreshTaxList()
    },
    taxDelete (index, id) {
      this.askQuestion(this.$t('tax.confirm.delete'), async () => {
        this.loading = true
        await this.$taxService.deleteTax(id)
          .then(data => {
            this.taxes.splice(index, 1)
            this.loading = false
            this.notify(this.$t('tax.message.deleted'), this.$t('status.success'))
            this.refreshTaxList()
          })
      })
    },
    showUsersDialog (id) {}
  },
  async mounted () {
    this.$emit('parent-title', this.$t('tax.title.tax'))
    try {
      await this.withLoading(async () => {
        this.taxes = await this.$taxService.getTaxes()
      }, 'loading')
    } catch (error) {
      // Error is already handled by the global interceptor
      console.log('Component caught error in getTaxes:', error)
    }
  },
  created () {
    this.$parent.$on('new-tax', this.newTax)
  }
}
</script>

<style scoped>

</style>
